import React, { useEffect, useState } from "react";
import { ReactComponent as FatigueAssessmentIcon } from "assets/icons/fatigue-assessment-filled.svg";
import './DrivingExemptions.css';
import { Link } from "react-router-dom";
import useSelector from 'hooks/useSelector';

import { gnhAdminSummaryDashboardOverview, gnhDrivingExemptionForm, gnhDrivingExemptionFormOnBehalf, gnhUsersSubmittedFormList, lvCommuteExemptionForm } from "./DrivingExemptionPageSelector";

import {
    ChevronRight as RightIcon,
    ExpandMore as DownIcon
} from '@mui/icons-material';
import { userHasPermission } from "../../../hooks/useRoles";
import { ISelectOption } from "../forms/util";

interface DrivingExemptionSidebarProps {
    selectedPage: ISelectOption
}

export const DrivingExemptionSidebar = (props: DrivingExemptionSidebarProps) => {
    const [currentSelection, setCurrentSelection] = useState(props.selectedPage);
    const profile = useSelector(state => state.profile);

    return (
        <>
            <div className="de-sidebar de-sidebar-nav">
                <div className="de-sidebar-title">
                    <FatigueAssessmentIcon />
                    <div className="d-inline-block">Driving Exemption</div>
                </div>

                <div className="de-sidebar-item">
                    <Link
                        to={gnhUsersSubmittedFormList.getRoute().path as string}
                        className={`${currentSelection == gnhUsersSubmittedFormList ? 'de-nav-selected' : ''}`}>
                        <div className="row">
                            <div className="col-11">{gnhUsersSubmittedFormList.label}</div>
                            <div className="col-1"><RightIcon /></div>
                        </div>
                    </Link>
                </div>

                <div className="de-sidebar-item">
                    <Link
                        to={gnhDrivingExemptionForm.getRoute().path as string}
                        className={`${currentSelection == gnhDrivingExemptionForm ? 'de-nav-selected' : ''}`}>
                        <div className="row">
                            <div className="col-11">{gnhDrivingExemptionForm.label}</div>
                            <div className="col-1"><RightIcon /></div>
                        </div>
                    </Link>
                </div>
                <div className="de-sidebar-item">
                    <Link
                        to={gnhDrivingExemptionFormOnBehalf.getRoute().path as string}
                        className={`${currentSelection == gnhDrivingExemptionFormOnBehalf ? 'de-nav-selected' : ''}`}>
                        <div className="row">
                            <div className="col-11">{gnhDrivingExemptionFormOnBehalf.label}</div>
                            <div className="col-1"><RightIcon /></div>
                        </div>
                    </Link>
                </div>
                <div className="de-sidebar-item">
                    <Link
                        to={lvCommuteExemptionForm.getRoute().path as string}
                        className={`${currentSelection == lvCommuteExemptionForm ? 'de-nav-selected' : ''}`}>
                        <div className="row">
                            <div className="col-11">{lvCommuteExemptionForm.label}</div>
                            <div className="col-1"><RightIcon /></div>
                        </div>
                    </Link>
                </div>
                
                {profile && userHasPermission("web.admin.gnh-exemption.exemption-request-dashboard", profile?.roles) &&
                    <>
                        <div className="de-sidebar-item">
                            <Link
                                to={gnhAdminSummaryDashboardOverview.getRoute().path as string}
                                className={`${currentSelection == gnhAdminSummaryDashboardOverview ? 'de-nav-selected ' : ''}`}>
                                <div className="row">
                                    <div className="col-11">{gnhAdminSummaryDashboardOverview.label}</div>
                                    <div className="col-1"><RightIcon /></div>
                                </div>
                            </Link>
                        </div>
                    </>
                }

            </div>

            {profile && userHasPermission("web.admin.gnh-exemption.exemption-request-dashboard", profile?.roles) &&
                <div className="fa-sidebar fa-sidebar-links">
                    <div className="fa-sidebar-title">Links</div>
                    <ul>
                        <li><Link to="/reporting/gnh-exemption">GNH Exemption reporting</Link></li>
                    </ul>
                </div>
            }
        </>
    );
}